import React, { useState, useRef } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import {
  SearchIcon,
  CloseIcon,
  ClickableBox,
  DebouncedGreyInvertedBigInput,
  InlineProductList,
  InfoParagraph,
  H4,
} from '../Components';
import { WithProductsSearch } from './WithProductsSearch';
import { DropdownPanel } from './DropdownPanel';
import { routes } from '../routes';
import { getTranslateByScope } from '../i18n';
import styles from './Search.module.scss';

const translate = getTranslateByScope('app.search');
const translatePreview = getTranslateByScope('app.productSearchPreview');

const MAX_RESULTS = 12;

const SearchResults = ({
  products, search, onSelect, onSeeAll,
}) => {
  if (!search) {
    return <InfoParagraph className={styles.message}>{translate('hint')}</InfoParagraph>;
  }

  const results = _.get(products, 'data') || [];
  if (!results.length) {
    return (
      <div className={styles.message}>
        <H4>{translatePreview('emptyState.title')}</H4>
        <InfoParagraph>{translatePreview('emptyState.description')}</InfoParagraph>
      </div>
    );
  }

  return (
    <>
      <div className={styles.resultsHeader}>
        <span className={styles.resultsLabel}>
          {translatePreview('topResultsLabel')}
        </span>
        <ClickableBox className={styles.seeAll} onClick={onSeeAll}>
          {translatePreview('seeAllResultsText')}
        </ClickableBox>
      </div>
      <InlineProductList
        products={results.slice(0, MAX_RESULTS)}
        onClick={onSelect}
      />
    </>
  );
};

const SearchPanel = withRouter(({
  isOpen, anchorRef, triggerRef, onClose, history,
}) => (
  <DropdownPanel
    isOpen={isOpen}
    anchorRef={anchorRef}
    triggerRef={triggerRef}
    onClose={onClose}>
    {/* Same nesting as the topbar - both classes on one element overflow */}
    <div className="margin-10p">
      <div className="container-fluid">
        <WithProductsSearch
          defaultSearch=""
          page={1}
          renderInputComponent={({ search, handleSearch }) => (
            <div className={styles.searchField}>
              <SearchIcon size="xs2" />
              <DebouncedGreyInvertedBigInput
                autoFocus
                className={styles.input}
                placeholder={translate('placeholder')}
                onChange={handleSearch}
                value={search}
              />
              <ClickableBox className={styles.close} onClick={onClose}>
                <CloseIcon size="xs2" />
              </ClickableBox>
            </div>
          )}>
          {({ products, search, setSearch }) => (
            <SearchResults
              products={products}
              search={search}
              onSelect={(name, color) => {
                setSearch('');
                history.push(routes.productDetail({ name, color }));
                onClose();
              }}
              onSeeAll={() => {
                history.push(`/productList?search=${encodeURIComponent(search)}`);
                onClose();
              }}
            />
          )}
        </WithProductsSearch>
      </div>
    </div>
  </DropdownPanel>
));

const Search = ({ anchorRef }) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const close = () => setIsOpen(false);

  return (
    <>
      <SearchPanel
        isOpen={isOpen}
        anchorRef={anchorRef || triggerRef}
        triggerRef={triggerRef}
        onClose={close}
      />
      <div ref={triggerRef}>
        <SearchIcon onClick={() => setIsOpen(!isOpen)} size="sm" />
      </div>
    </>
  );
};

export default Search;
